import { useForm } from 'react-hook-form'
import { t } from '../../../../utils'
import LabModal from '../../components/LabModal'
import styles from './_reportPostModal.module.scss'
import { ReactSVG } from 'react-svg'
import classNames from 'classnames'
import { useMutation } from '@apollo/client'
import {
  COMMUNITY_POST_QUERY,
  COMMUNITY_POSTS_QUERY,
  COMMUNITY_REPORT_POST_MUTATION
} from '../../../../gql'
import useLabErrorHandling from '../../../../utils/hooks/useLabErrorHandling'
import { getOperationName } from 'apollo-boost'

type ReportInputs = {
  report: string
}

const ReportPostModal: React.FC<{
  postId: number
  onClose: () => void
  onReported: () => void
}> = ({ onClose, onReported, postId }) => {
  const { register, handleSubmit, errors } = useForm<ReportInputs>({
    defaultValues: { report: '' }
  })

  const errorHandling = useLabErrorHandling()

  const [reportPost, { loading }] = useMutation(
    COMMUNITY_REPORT_POST_MUTATION,
    {
      refetchQueries: [
        getOperationName(COMMUNITY_POSTS_QUERY),
        getOperationName(COMMUNITY_POST_QUERY)
      ]
    }
  )

  const onSubmit = (data: ReportInputs) => {
    reportPost({
      variables: {
        postId,
        details: data.report
      },
      onCompleted: () => {
        onReported()
        onClose()
      },
      onError: errorHandling
    })
  }

  return (
    <div className={styles.reportModal}>
      <LabModal
        onClose={onClose}
        overlayStyle={styles.overlay}
        contentContainerStyle={styles.reportModalContainer}
      >
        <header>
          <h2 className={styles.reportModalTitle}>
            {t('Does this post go against our community guidelines?')}
            <br />
            {t('Please include the details below. Thank you!')}
          </h2>
          <ReactSVG src="../../../images/lab/report_icon.svg" />
        </header>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.reportInputContainer}>
            {errors.report && (
              <p className={styles.errorMessage}>{errors.report.message}</p>
            )}
            <textarea
              className={classNames('input', styles.reportField, {
                [styles.error]: errors.report
              })}
              name="report"
              ref={register({ required: t('Is required') })}
            />
          </div>

          <div className={styles.buttons}>
            <button
              className={'button lab-button lab-button-dark'}
              onClick={onClose}
            >
              {t('Cancel')}
            </button>

            <button
              className={'button lab-button'}
              disabled={loading}
              type="submit"
            >
              {t('Submit')}
            </button>
          </div>
        </form>
      </LabModal>
    </div>
  )
}

export default ReportPostModal
